import { styled } from '@mui/system';
import { ListItemWrapper } from 'pages/NotificationCenter/MedicationTracker/Detailed/ReminderCard/styles';

export const SearchResultListItemWrapper = styled(ListItemWrapper)(
  ({ theme }) => ({})
);
